var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"variant":"warning","href":"#","title":_vm.issues.toString()}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"circle-exclamation"}}),(_vm.issues.length === 1)?_c('span',[_vm._v("1 issue")]):_c('span',[_vm._v(_vm._s(_vm.issues.length)+" issues")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }